module.exports = __webpack_public_path__ + "static/media/Bhutan.4e43cbd9.png";